import React from 'react';
import { Image, ImageSourcePropType, StyleSheet, Text, View } from 'react-native';

import { fonts, scale } from '../Styles';

type LegendAttribute = { title: string; asset: ImageSourcePropType };

const legendAttributes: LegendAttribute[] = [
  { title: 'Done', asset: require('../assets/black_square.png') },
  { title: 'Needed', asset: require('../assets/empty_square.png') },
  { title: 'Honors', asset: require('../assets/black_star.png') },
  { title: 'Partial', asset: require('../assets/black_swoop.png') },
  { title: 'In Progress', asset: require('../assets/black_dot.png') },
];

export const MNOHSCourseLegends = () => {
  return (
    <View style={styles.legendContainer}>
      {legendAttributes.map((section: LegendAttribute, i: number) => (
        <View style={styles.legendTileContainer} key={i}>
          <Image source={section.asset} style={styles.legendTile} resizeMode="contain" />
          <Text style={styles.legendText}>{section.title}</Text>
        </View>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  legendContainer: {
    flex: 1,
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'space-evenly',
    paddingTop: '5%',
    marginBottom: '5%',
  },
  legendTileContainer: {
    width: '100%',
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: scale(50),
  },
  legendTile: {
    alignSelf: 'center',
    aspectRatio: 1 / 1,
    width: '40%',
    height: '40%',
  },
  legendText: {
    ...fonts.linkedText,
    lineHeight: scale(14),
    fontSize: scale(13),
    textTransform: 'uppercase',
    textAlign: 'center',
  },
});
